import React, {useContext} from "react";
import "../../styles/pages/home/ThankYouPage.scss";
import { Trans, useTranslation } from "react-i18next";
import { GlobalContext } from "../../App";



function WaitingListPage() {
  const { infoData } = useContext(GlobalContext);
  const { t, i18n } = useTranslation();
  return (
    <div className="waiting-list-page-container">
      <br></br>
      <div className="waiting-list-title">
           {i18n.language === "hk" ? (
          <span>
            <Trans i18nKey="waitingListPage:waiting_title">
              {infoData.title_tc}
              {infoData.title_tc}
            </Trans>
          </span>
        ) : (
          <span>
           <Trans i18nKey="waitingListPage:waiting_title">
              {infoData.title_eng}
              {infoData.title_eng}
            </Trans>
          </span>
        )}

      </div>
    </div>
  );
}

export default WaitingListPage;
